import { Component, h } from 'preact'
import Card from '../cards/index'
import Phrase from '../../libs/translationsUtils/phrase'
import { ParentCategory, Category } from '../community-category/index.sync'

interface Props {
  selectedTemplate: number,
  title: string,
  categories: Array<ParentCategory>
}

class KnowledgeBase extends Component<Props> {
  constructor (props: Props) {
    super(props)
    this.getMetadata = this.getMetadata.bind(this)
  }

  templates = ['big-card', 'small-card']

  getMetadata (categories: Array<Category>) {
    let totalTopicCount = 0

    categories.forEach(category => {
      totalTopicCount += category.topicCount
    })

    return (
      <div class='knowledge-base__card-metadata'>
        <p className='text--meta'>{ <Phrase m='Common' p='knowledge.base.articles' count={{ n: totalTopicCount.toString() }} /> }</p>
      </div>
    )
  }

  render ({ title, selectedTemplate, categories }: Props) {
    if (!categories.length) {
      return null
    }

    return (
      <section
        className='full-width Template-brand-featured homepage-widget-wrapper knowledge-base-container qa-knowledge-base-container custom-knowledge-base'>
        <div className='sitewidth'>
          <div className='col'>
            {
              title ? <h3 className='widget__heading'>{title}</h3> : null
            }
            <div className='knowledge-base-category-list'>
              {
                categories.map((category, idx) => (
                  <Card
                    customClass={`knowledge-base__card knowledge-base__card-${this.templates[selectedTemplate]}`}
                    idx={idx}
                    title={category.title}
                    metadata={this.getMetadata(category.subforums)}
                    imageSrc={category.thumbnailUrl}
                    navigation={{
                      url: category.url
                    }}
                  />
                ))
              }
            </div>
          </div>
        </div>
      </section>
    )
  }
}

export default KnowledgeBase
